import { Component } from "@angular/core";
import { Annee } from "../core/model/annee";
import { AnneeService } from "../core/service/annee.service";

@Component({
  selector: "app-annee",
  templateUrl: "./annee.component.html",
  styleUrls: ["./annee.component.scss"],
})
export class AnneeComponent {
  annees: Annee[];

  constructor(private _anneeService: AnneeService) {}

  ngOnInit() {
    this.getAll();
  }

  getAll() {
    this._anneeService.getAll().subscribe(
      (data) => {
        this.annees = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }
}
